import React from 'react'
import PropTypes from 'prop-types'
import MailCheckInput from '../../organisms/MailCheckInput'

export const EmailRevalidateInput = ({
  onMailCheckSuggestionClick,
  isSubmitting,
  inputWrapper,
  clearErrors,
}) => {
  return (
    <>
      {inputWrapper(({ field, fieldState: { error, ...restFields } }) => (
        <MailCheckInput
          onFocus={clearErrors}
          label="Endereço de e-mail"
          disabled={isSubmitting}
          onSuggestionClick={onMailCheckSuggestionClick}
          {...field}
          {...restFields}
          hasError={!!error}
        />
      ))}
    </>
  )
}

EmailRevalidateInput.propTypes = {
  onMailCheckSuggestionClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  inputWrapper: PropTypes.any,
  clearErrors: PropTypes.func,
}
